import ReportViewComponent from '@/components/Pages/ReportView.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/report/:reportId/folder/:folderId',
  props: true,
  name: RouteNames.Folder,
  component: ReportViewComponent,
};

export default route;
